import { Component, Input, inject } from '@angular/core';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-holiday-form',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './holiday-form.component.html',
  styleUrl: './holiday-form.component.scss'
})
export class HolidayFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  HolidayDetail = {
    ESS_HolidayMasterID: 0,
    HolidayName: null,
    HolidayType: null,
    SelectType: 'insert',
    //Active: true,
  }
  constructor(
    private toast: ToastService,
    private holiday: HolidayService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip : TooltipService
  ) {
    this.common.getPageRights();
    this.HolidayDetail.ESS_HolidayMasterID = this.ID;
  }

  ngOnInit(): void {
    if(this.HolidayDetail.ESS_HolidayMasterID == undefined){
      this.HolidayDetail.ESS_HolidayMasterID = 0;
    }
    if (this.ID > 0) {
      this.GetHoliday();
    }
  }

  GetHoliday() {
    this.isDisabled = true;
    this.HolidayDetail.ESS_HolidayMasterID = this.ID;
    this.holiday.GetHoliday({ ESS_HolidayMasterID: this.HolidayDetail.ESS_HolidayMasterID, SelectType: 2 }).subscribe({
      next: (response) => {
        this.HolidayDetail = response.Table[0];
        this.HolidayDetail.SelectType = 'update';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.HolidayDetail.HolidayName != null && this.HolidayDetail.HolidayType != null) {
        this.SaveHoliday();
      }
    }
    else {
      form.submitted = true;
    }
  }

  async SaveHoliday() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result) => {
      if((this.HolidayDetail.ESS_HolidayMasterID == 0 && this.common.PageRight.IsAdd) || (this.HolidayDetail.ESS_HolidayMasterID > 0 && this.common.PageRight.IsEdit)){
        if (result) {
          this.isDisabled = true;
          this.HolidayDetail.ESS_HolidayMasterID = this.ID;
          this.holiday.SaveHoliday(this.HolidayDetail).subscribe({
            next: (response) => {
              if (response.Error_Code == '379' || response.Error_Code == '380') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.activeModal.close();
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              console.log(response.Error_Message);
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }else{
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  close() {
    this.activeModal.close();
  }
}
